import { runtimeEnv } from "config/runtimeEnv";
import {API_ENDPOINT}  from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = runtimeEnv("API_BASE_URL")

export const  loginApi = async(user) => {
  const data = user || {};
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.Login.api}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

// Identify-first (common-URL) login: resolve which tenant(s) know this user
// before the actual login call. Returns the raw body ({success, data:[...]})
// or undefined on network failure — callers treat anything falsy as "proceed
// with login as before" (fail-open, subdomain deployments unaffected).
export const identifyApi = async(user) => {
  const data = user || {};
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.Identify.api}`,
    data
  )
  .catch((err) =>  err.response)
  return res?.data
}

export const magicTokenApi = async(user) => {
  const data = user || {};
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.Login.magicToken}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const tokenVerifyApi = async(id) => {
  const data = {
    id:id
  } || {};
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.Login.tokenVerify}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
